module.exports = __webpack_public_path__ + "static/media/kw1200 blue.6e3cba5b.JPG";